import { RemesaFlujoTesoreriaDtoProps } from "./DTOs/RemesaFlujoTesoreriaDto"
import { RemesaReadingDtoProps } from "./DTOs/RemesaReadingDto"
import { RemesaReadingFilteredDtoProps } from "./DTOs/RemesaReadingFilteredDto"

export function remesaReadingFilteredDtoAdapter(
  remesa: RemesaReadingFilteredDtoProps
): RemesaReadingFilteredDtoProps {
  return {
    id: remesa?.id,
    concepto: remesa?.concepto,
    fecha: remesa?.fecha,
    fechaVencimiento: remesa?.fechaVencimiento,
    iban: remesa?.iban,
    importe: remesa?.importe,
    numeroMovimientos: remesa?.numeroMovimientos,
    tipo: remesa?.tipo,
    tipoRemesable: remesa?.tipoRemesable,
  }
}

export function remesaReadingDtoAdapter(
  remesa: RemesaReadingDtoProps
): RemesaReadingDtoProps {
  return {
    id: remesa?.id,
    concepto: remesa?.concepto,
    cuentaBancariaId: remesa?.cuentaBancariaId,
    fechaVencimiento: remesa?.fechaVencimiento,
    identificador: remesa?.identificador,
    tipo: remesa?.tipo,
  }
}

export function remesaFlujoTesoreriaDtoAdapter(
  remesa: RemesaFlujoTesoreriaDtoProps
): RemesaFlujoTesoreriaDtoProps {
  return {
    id: remesa?.id,
    documento: remesa?.documento,
    facturaId: remesa?.facturaId,
    fecha: remesa?.fecha,
    fechaVencimiento: remesa?.fechaVencimiento,
    importeRemesado: remesa?.importeRemesado,
    importeTotal: remesa?.importeTotal,
    prestamoId: remesa?.prestamoId,
    razonSocial: remesa?.razonSocial,
  }
}
